import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { getPublicConfig } from "@/helpers/getPublicConfig";

const {
  features: {
    business: { maxJobInvitations },
  },
} = getPublicConfig();

export const getInviteModelFormYupResolver = (invitationsCount: number = 0) => {
  const invitationQuota = maxJobInvitations - invitationsCount;
  return yupResolver(
    yup.object().shape({
      modelUserIds: yup
        .array()
        .min(1)
        .max(invitationQuota, "邀請人數已超過限額")
        .required(),
    }),
  );
};
